export default {
  setDescriptionContent(state, payload) {
    state.descriptionContent = payload;
  },
  setTitleContent(state, payload) {
    state.titleContent = payload;
  },
  setTitleTag(state, payload) {
    state.titleTag = payload;
  },
  setMetaData(state, payload) {
    state.descriptionContent = payload.metaDescription;
    state.titleContent = payload.metaTitle;
    state.titleTag = payload.titleTag;
  },
};
